import { useCallback, useEffect, useState } from "react";

import { useAdminFetch } from "../../admin/hooks/useAdminFetch";

const safeJsonParse = async (response, fallback) => {
  try {
    return JSON.parse(await response.text());
  } catch {
    return fallback;
  }
};

export function useStakeholderDispositionHistory(item) {
  const adminFetch = useAdminFetch();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const loadEntries = useCallback(async () => {
    if (!item?.source_type || !item?.source_id) {
      setEntries([]);
      setError("");
      return;
    }

    setLoading(true);
    setError("");
    try {
      const params = new URLSearchParams({
        source_type: item.source_type,
        source_id: item.source_id,
      });
      const response = await adminFetch(`/admin/stakeholder/dispositions/history?${params.toString()}`);
      const payload = await safeJsonParse(response, { entries: [] });
      if (!response.ok) {
        throw new Error(payload.detail || "Failed to load disposition history");
      }
      setEntries(Array.isArray(payload.entries) ? payload.entries : []);
    } catch (fetchError) {
      setError(fetchError.message || "Failed to load disposition history");
    } finally {
      setLoading(false);
    }
  }, [adminFetch, item?.source_id, item?.source_type]);

  useEffect(() => {
    loadEntries();
  }, [loadEntries]);

  return {
    entries,
    error,
    loading,
    refresh: loadEntries,
  };
}
